import ArrowRight from "@/components/svg/ArrowRight";
import Styles from "./NavigationLink.module.scss";

type NavigationLinkProps = {
  linkText: string;
  href: string;
  onClick?: () => void;
};

const NavigationLink = ({ linkText, href, onClick }: NavigationLinkProps) => (
  <a
    href={href}
    target="_blank"
    rel="noreferrer"
    className={Styles.link}
    onClick={onClick}
  >
    <div className={Styles.content}>
      <p className={Styles.text}>{linkText}</p>
      <ArrowRight height={9} width={5} />
    </div>
  </a>
);

export default NavigationLink;
